import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';

class OtherApps extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>My other apps:</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I am currently working on some web and IoT apps that will be posted here soon.</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default OtherApps



// WEBPACK FOOTER //
// src/Apps/OtherApps.js